/* ******
 * THIS CODE IS COPY-PASTED FROM THE DIRECT UNIVERSAL SOY TEMPLATE
 ***** */

export function addFacebookLogin(facebookAppId) {
  window.fbAsyncInit = function () {
    FB.init({
      appId: facebookAppId,
      xfbml: false,
      cookie: true,
      version: 'v17.0',
      status: true,
    })
  }
  addFacebookLoginScript(document, 'script', 'facebook-jssdk')
}

export function addGoogleLogin() {
  const createCookie = (name, value, days) => {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = `; expires=${date.toGMTString()}`
    }
    document.cookie = `${name}=${value}${expires}; path=/`
  }

  createCookie('G_AUTH2_MIGRATION', 'enforced', 90)

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  window.initGoogleAPI =
    window.initGoogleAPI ||
    function () {
      gapi.client.load('plus', 'v1')
    }
}

/* eslint-disable */
function addFacebookLoginScript(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = 'https://connect.facebook.net/en_US/sdk.js'
  js.deffer = true
  js.async = true
  fjs.parentNode.insertBefore(js, fjs)
}
/* eslint-enable */
